import { GovFlex } from '@gov-design-system-ce/react';
import { createStepTitleId, type FormWizardHook } from '@gov-nx/core/hooks';
import { Button } from '@gov-nx/ui/web';
import { scrollToElement } from '@gov-nx/web';

interface WizardRecapHeaderProps<T extends object> {
	wizard: FormWizardHook<T>;
	title: string;
	stepIndex: number;
	strings: {
		label: string;
		wcagLabel: string;
	};
	disabled?: boolean;
}

export const WizardRecapHeader = <T extends object>({
	title,
	strings,
	stepIndex,
	wizard,
	disabled = false,
}: WizardRecapHeaderProps<T>) => {
	const focusToElement = (stepIndex: number) => {
		const id = createStepTitleId(stepIndex, wizard.wizardId);
		const step = wizard.step(stepIndex);
		const element = document.getElementById(id);

		if (step.isExpanded) {
			scrollToElement(element);
			element?.focus({ preventScroll: true });
		} else {
			wizard.openStep(stepIndex, true);
			// wait for the gov-wizard to expand the step and scroll to it
			setTimeout(() => {
				scrollToElement(element);
			}, 100);
		}
	};

	return (
		<GovFlex
			gap="s"
			alignItems="center"
			responsive="false">
			<h3 className="text-headline-s!">{title}</h3>
			{stepIndex !== undefined && (
				<Button
					onClick={() => focusToElement(stepIndex)}
					aria-label={strings.wcagLabel}
					color="primary"
					isDisabled={disabled}
					type="base"
					size="s">
					{strings.label}
				</Button>
			)}
		</GovFlex>
	);
};
